export default (state = [], action) => {
	switch (action.type) {
		case "SET_PRICELIST_SELECTION":
			return action.selection;
		default:
			return state;
	}
};
